import { parseTemplate } from 'url-template';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import ErrorResponse from './ErrorResponse';
import List from './List';
import mapList from './mapList';

export interface Result {
	czReimbursement: List;
}

export default function findList(client: ApiClient, userId: string, groupId: string): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/cz-reimbursement-list');
	return client
		.fetch(url.expand({ userId, groupId }))
		.then((response) => response.json())
		.then((response) => ({
			czReimbursement: mapList(response.czReimbursement),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, ErrorResponse));
}
